import { render, staticRenderFns } from "./horizontal-scroll.vue?vue&type=template&id=04a6c994&"
import script from "./horizontal-scroll.vue?vue&type=script&lang=js&"
export * from "./horizontal-scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports